export default {
  name: 'videoPlayer',
  component() {
    return {
      isPlaying: false,
      isPosterVisible: true,
      videos: [],
      // Optional auto-hide for the pause control (data-controls-hide-delay, ms): once playback starts it hides
      // after the delay even while hovered; leaving the player resets it, so after that it follows hover.
      controlsHideDelay: 0,
      controlsHideTimer: null,
      isControlIdle: false,

      get activeVideo() {
        return this.videos.find((video) => video.offsetParent !== null) || this.videos[0] || null;
      },

      get activeIframe() {
        const iframes = Array.from(this.$el.querySelectorAll('iframe'));
        return iframes.find((iframe) => iframe.offsetParent !== null) || iframes[0] || null;
      },

      init() {
        this.controlsHideDelay = Number(this.$el.dataset.controlsHideDelay) || 0;
        this.videos = Array.from(this.$el.querySelectorAll('video'));
        this.videos.forEach((video) => {
          video.addEventListener('play', () => this.syncFrom(video));
          video.addEventListener('pause', () => this.syncFrom(video));
          video.addEventListener('ended', () => this.syncFrom(video));
        });
        this.syncFrom(this.activeVideo);
      },

      syncFrom(video) {
        if (!video) {
          this.isPlaying = false;
          return;
        }
        this.isPlaying = !video.paused && !video.ended;

        if (this.isPlaying) {
          this.scheduleControlIdle();
        } else {
          this.resetControlIdle();
        }

        // Playback started some other way (the native controls, the play/pause
        // button) - the poster has no reason to sit over a playing video.
        if (this.isPlaying) {
          this.isPosterVisible = false;
        }
      },

      scheduleControlIdle() {
        if (!this.controlsHideDelay) return;
        clearTimeout(this.controlsHideTimer);
        this.isControlIdle = false;
        this.controlsHideTimer = setTimeout(() => {
          this.isControlIdle = true;
        }, this.controlsHideDelay);
      },

      resetControlIdle() {
        clearTimeout(this.controlsHideTimer);
        this.isControlIdle = false;
      },

      destroy() {
        clearTimeout(this.controlsHideTimer);
      },

      toggle() {
        const video = this.activeVideo;
        if (!video) return;

        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      },

      // Dismiss the poster and start playback. Native videos play directly;
      // embeds reload with autoplay, which the click counts as consent for.
      playFromPoster() {
        this.isPosterVisible = false;

        const video = this.activeVideo;
        if (video) {
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') {
            playback.catch(() => {});
          }
          return;
        }

        const iframe = this.activeIframe;
        if (!iframe || !iframe.src) return;

        try {
          const embedUrl = new URL(iframe.src, window.location.href);
          embedUrl.searchParams.set('autoplay', '1');
          iframe.src = embedUrl.toString();
        } catch (error) {
          // Leave the embed untouched if its src cannot be parsed.
        }
      }
    };
  }
};
